export default {
  strict: true,
  namespaced: true,
  state: {
    name: null
  },
  getters: {},
  actions: {},
  mutations: {
    setUser (state, user) {
      state.name = user.name
    }
  }
}
